'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductPartsService = function () {
  function ProductPartsService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ProductPartsService);
    this.api = Api;
  }

  (0, _createClass3.default)(ProductPartsService, [{
    key: 'loadAllShapes',
    value: function loadAllShapes() {
      return this.api.call({
        method: 'get',
        url: '/shapes'
      });
    }
  }, {
    key: 'loadAllFixmethods',
    value: function loadAllFixmethods() {
      return this.api.call({
        method: 'get',
        url: '/fixmethods'
      });
    }
  }, {
    key: 'loadAllColors',
    value: function loadAllColors() {
      return this.api.call({
        method: 'get',
        url: '/colors'
      });
    }
  }]);
  return ProductPartsService;
}();

// WEBPACK FOOTER //


exports.default = ProductPartsService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-parts/parts.service.js
 **/